import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import "@fontsource-variable/geist";
import "@/ui/styles/app.css";
import "@/ui/styles/web.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Element #root wurde nicht gefunden.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
